'use client'
import { CardText } from '@morpho-org/ui-v6/server'
import { memo } from 'react'

import { SubSectionTitle } from '@/components/common/SubSectionTitle'

const AllocatorDataListError = () => {
  return (
    <div className="gap-2xs flex flex-col">
      <SubSectionTitle>Risk Curation</SubSectionTitle>
      <CardText height="120px" text="An error occurred." />
    </div>
  )
}

export default memo(AllocatorDataListError)
